import { useLanguageCode } from "./index";
import React from "react";
import { Navigate, useLocation } from 'react-router-dom';
export const RedirectToUrlWithLanguageCode = () => {
    const [lang] = useLanguageCode();
    const location = useLocation();
    return (React.createElement(Navigate, { to: Object.assign(Object.assign({}, location), { pathname: lang + location.pathname }), state: location.state }));
};
//# sourceMappingURL=RedirectToUrlWithLanguageCode.js.map